import {Link, useLocation, useNavigate} from "react-router-dom";
import "./PlanDetailsComponent.scss";
import {PlanItem} from "../../shared/interfaces";
import {PLAN_STATUS} from "../../shared/enums";

const STATUS_LABELS: Record<string, string> = {
	completed: 'Виконано',
	inProgress: 'Виконується',
	notCompleted: 'Не виконано',
	ongoing: 'Постійно',
};

const STATUS_COLORS: Record<string, string> = {
	completed: '#2e7d32',
	inProgress: '#ed6c02',
	notCompleted: '#d32f2f',
	ongoing: '#757575',
};

const STATUS_WIDTHS: Record<string, string> = {
	completed: '100%',
	inProgress: '50%',
	notCompleted: '10%',
	ongoing: '100%',
};

const PlanDetailsComponent = () => {
	const location = useLocation();
	const item: PlanItem = location.state;
	const navigate = useNavigate();
	const statusKey = PLAN_STATUS[item?.status] || item?.status;

	const statusColor = STATUS_COLORS[statusKey] || '#757575';
	const statusWidth = STATUS_WIDTHS[statusKey] || '0%';

	return (
		<div className="details_wrapper">
			{/* ── Hero ── */}
			<div className="details_hero">
				<div className="details_hero_top">
					<button onClick={() => navigate(-1)} className="details_back">
						<img src="/assets/icons/back.png" alt="Back" />
					</button>
					<div className="details_breadcrumb">
						<Link to="/plans">План дій</Link>
						<span>/</span>
						Деталі
					</div>
				</div>

				{item?.action_number && (
					<div className="details_hero_number">Захід #{item.action_number}</div>
				)}
				<div className="details_hero_title">
					{item?.short_action_name || item?.action_name || 'Деталі заходу'}
				</div>
				{statusKey && (
					<div className={`details_hero_badge details_hero_badge--${statusKey}`}>
						<div className="details_hero_dot" />
						{STATUS_LABELS[statusKey] || statusKey}
					</div>
				)}
			</div>

			{/* ── Floating progress bar ── */}
			{statusKey && (
				<div className="details_progress">
					<div className="details_progress_card">
						<span className="details_progress_label">Стан виконання</span>
						<div className="details_progress_track">
							<div
								className="details_progress_fill"
								style={{ width: statusWidth, backgroundColor: statusColor }}
							/>
						</div>
						<span className="details_progress_text" style={{ color: statusColor }}>
							{STATUS_LABELS[statusKey] || statusKey}
						</span>
					</div>
				</div>
			)}

			{/* ── Body ── */}
			<div className="details_body">
				{/* Description callout */}
				{item?.action_name && (
					<div className="details_description">
						<div className="details_description__label">Повне найменування заходу</div>
						<div className="details_description__text">{item.action_name}</div>
					</div>
				)}

				{/* Detail rows */}
				<div className="details_fields">
					{item?.execution_deadline && (
						<div className="details_row">
							<div className="details_row__label">Строк виконання</div>
							<div className="details_row__value">{item.execution_deadline}</div>
						</div>
					)}
					{item?.executor && (
						<div className="details_row">
							<div className="details_row__label">Виконують</div>
							<div className="details_row__value">{item.executor}</div>
						</div>
					)}
					{item?.responsible_parties?.length > 0 && (
						<div className="details_row">
							<div className="details_row__label">Відповідальні</div>
							<div className="details_row__value">{item.responsible_parties.join(', ')}</div>
						</div>
					)}
					{item?.execution_status && (
						<div className="details_row">
							<div className="details_row__label">Стан виконання</div>
							<div className="details_row__value">{item.execution_status}</div>
						</div>
					)}
					{item?.performance_indicator && (
						<div className="details_row">
							<div className="details_row__label">Індикатор виконання</div>
							<div className="details_row__value">{item.performance_indicator}</div>
						</div>
					)}
				</div>

				</div>
		</div>
	);
};

export default PlanDetailsComponent;
